import React, { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";

const ROLE_STYLES = {
  patient: "bg-primary/10 text-primary",
  doctor: "bg-accent/15 text-accent",
  hospital: "bg-secondary/15 text-secondary",
  admin: "bg-destructive/10 text-destructive",
};

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [role, setRole] = useState("all");

  const load = async () => {
    const params = {};
    if (role !== "all") params.role = role;
    const { data } = await api.get("/admin/users", { params });
    setUsers(data);
  };

  useEffect(() => { load(); }, [role]);

  return (
    <AppShell
      pageTitle="Users"
      pageDescription="All accounts across patient, doctor, hospital and admin roles."
      actions={
        <Select value={role} onValueChange={setRole}>
          <SelectTrigger className="w-44" data-testid="admin-users-role-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All roles</SelectItem>
            <SelectItem value="patient">Patients</SelectItem>
            <SelectItem value="doctor">Doctors</SelectItem>
            <SelectItem value="hospital">Hospitals</SelectItem>
            <SelectItem value="admin">Admins</SelectItem>
          </SelectContent>
        </Select>
      }
    >
      <div className="rounded-lg border border-border bg-white overflow-hidden" data-testid="admin-users-table">
        <table className="w-full text-sm">
          <thead className="bg-muted/60">
            <tr className="text-left text-[10px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Role</th>
              <th className="px-4 py-3">Provider</th>
              <th className="px-4 py-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-border" data-testid={`user-row-${u.id}`}>
                <td className="px-4 py-3 font-medium text-primary">{u.name}</td>
                <td className="px-4 py-3 text-muted-foreground">{u.email}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] uppercase tracking-wider rounded-full px-2 py-0.5 ${ROLE_STYLES[u.role] || ROLE_STYLES.patient}`}>
                    {u.role}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{u.auth_provider || "password"}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{formatDate(u.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}

function formatDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" }); }
  catch { return iso; }
}
